import * as React from "react";

function FilePdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.22 20.08C19.37 22 41.51 42.71 43 35.8s-26.33 2.89-21.41 7.68 11.48-25.27 4.63-23.4z"
  }));
}

export default FilePdfIcon;